import { useEffect, useState } from 'react';
import { OfferProgress, RadioButtons } from './styled';

export default function B2G1ProgressRadioButton(props) {
  const {
    offerCartData,
    lockedProductSectionRef,
    setShowLockedProductsAnimation,
    showNewCDDDPage,
    isDesktop,
  } = props;
  const [animationComplete, setAnimationComplete] = useState(false);
  const [freebieUnlocked, setFreebieUnlocked] = useState(false);
  const [firstRadioState, setFirstRadioState] = useState('2');
  const [secondRadioState, setSecondRadioState] = useState('1');

  useEffect(() => {
    let count = 0;
    offerCartData?.productList?.map((element) => {
      if (!element?.addToCart) {
        if (element?.quantity > 1) {
          for (let i = 1; i < element?.quantity; i++) {
            count++;
          }
        }
        count++;
      }
    });

    if (count >= 2) {
      setTimeout(() => {
        setAnimationComplete(true);
      }, 200);
      setFreebieUnlocked(true);
    } else {
      setAnimationComplete(false);
      setFreebieUnlocked(false);
    }

    if (count >= 3) {
      setSecondRadioState('3');
    } else if (count >= 2) {
      setFirstRadioState('3');
      setSecondRadioState('2');
    } else {
      setFirstRadioState('2');
      setSecondRadioState('1');
    }
  }, [offerCartData?.productList]);

  const handleClick = () => {
    const element = lockedProductSectionRef.current;
    const offset = 70;
    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: elementPosition - offset,
      behavior: 'smooth',
    });

    setShowLockedProductsAnimation(true);
    setTimeout(() => {
      setShowLockedProductsAnimation(false);
    }, 1000);
  };

  const getProgessStateImage = (option) => {
    switch (option) {
      case '1':
        return 'https://images.myloapp.in/NestJsUploads/1737093961433-radio-inactive.svg';
      case '2':
        return 'https://images.myloapp.in/NestJsUploads/1737090830121-Radio-button-active.svg';
      case '3':
        return 'https://images.myloapp.in/NestJsUploads/1737623911716-Done-state.svg';
    }
  };

  return (
    <OfferProgress>
      <img
        className="featureImages"
        src={
          showNewCDDDPage
            ? isDesktop
              ? 'https://images.myloapp.in/NestJsUploads/1753953083941-uspdesktop.webp'
              : 'https://images.myloapp.in/NestJsUploads/1753953056997-uspmobile.webp'
            : ' https://images.myloapp.in/NestJsUploads/1737625573056-Trust-element.webp'
        }
        alt="Cloth Diaper Features"
        width="100%"
        height="100%"
        style={{
          height: isDesktop ? '90px' : '',
          width: isDesktop ? '800px' : 'auto',
        }}
      />
      <img
        src={
          false
            ? 'https://images.myloapp.in/NestJsUploads/1753953568467-Mask-group.webp'
            : 'https://images.myloapp.in/NestJsUploads/1737531538292-Offer-section-header-1.webp'
        }
        alt="Offer Price"
        width="100%"
        height="100%"
        className="bannerWrapper"
      />
      <RadioButtons freebieUnlocked={freebieUnlocked}>
        <div className="radioButton">
          <img src={getProgessStateImage(firstRadioState)} alt="" />
          <p className="active">
            Select any
            <br /> 2 cloth diapers
          </p>
        </div>
        <div className="horizontalLine"></div>
        <div className="radioButton" onClick={handleClick}>
          <img src={getProgessStateImage(secondRadioState)} alt="" />
          <p className={animationComplete ? 'active' : 'inactive'}>
            Choose your FREE Diaper pack
          </p>
        </div>
      </RadioButtons>
    </OfferProgress>
  );
}
